const styles = {
  root: {
    marginBottom: 20,
  },
  heading: {
    padding: '10px 0',
  },
  select: {
    width: 250,
  },
  alert: {
    maxWidth: 520,
    marginTop: 8,
  },
};

export default styles;
